import { useContext, useEffect, useState } from 'react'
import { Grid, Typography, FormControl, TextField, Autocomplete, Stack, Box, } from '@mui/material'
import dashboardStyle from '../../Styles/ComponentStyles/Dashboard/SuperAdminDashboard.module.scss'
import agents from '../../assets/Images/Dashboard/Agent.svg'
import profiles from '../../assets/Images/Dashboard/profiles.svg'
import activeAgent from '../../assets/Images/Agent/Active Agent.svg'
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { UserContext, UserContextPayload } from '../../Context/UserDetailContext'
import { useSnackbar } from '../../GlobalComponent/GlobalSnackbar/GlobalSnackbar'
import { DataGrid } from '@mui/x-data-grid'
import CustomPagination from '../../GlobalComponent/CustomPagination/CustomPagination'
import { AdminDashboardContext, AdminDashboardContextPayload } from '../../Context/AdminDetailsContext'
import 'rsuite/dist/rsuite.min.css';
import CustomDateRangePicker from '../../GlobalComponent/CustomDateRangePicker'
import { subYears } from 'date-fns'
import DomainIcon from '@mui/icons-material/Domain';

const SuperAdminDashboard = () => {

    const {
        setFlagLoader
    } = useContext(UserContext) as UserContextPayload

    const {
        getSuperAdminDashboardDetailsAPI
    } = useContext(AdminDashboardContext) as AdminDashboardContextPayload

    const { showSnackbar } = useSnackbar();

    const [selectedCompany, setSelectedCompany] = useState<any>("All Companies");
    const [companyOptions, setCompanyOptions] = useState<any>([]);
    const [dateRange, setDateRange] = useState({
        startDate: subYears(new Date(), 1).toISOString().split('T')[0], // One year before
        endDate: new Date().toISOString().split('T')[0], // Current date
    });
    const [superAdminDashboardData, setSuperAdminDashboardData] = useState<any>({});

    const chipDetails = [
        {
            name: "# Companies",
            number: superAdminDashboardData?.overall?.total_companies,
            img: DomainIcon,
            flag: false
        },
        {
            name: "# Agents",
            number: superAdminDashboardData?.overall?.total_agents,
            img: agents,
            flag: false
        },
        {
            name: "# Profiles",
            number: superAdminDashboardData?.overall?.total_profiles,
            img: profiles,
            flag: false
        },
        {
            name: "# Active Agents (Last 30 days)",
            number: superAdminDashboardData?.overall?.active_agents,
            img: activeAgent,
            flag: true
        },
    ]

    const agentListColumns: any = [
        {
            field: 'company_name',
            headerName: 'COMPANIES',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 125,
            renderCell: (params: any) => {
                let row = params.row
                return (
                    <>{row.company_name}</>
                )
            }
        },
        {
            field: 'firstname',
            headerName: 'AGENT NAME',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 200,
            renderCell: (params: any) => {
                let row = params.row
                return (
                    <>
                        <Grid item>
                            <Grid container flexWrap={"nowrap"}>
                                <Grid item>
                                    {row?.firstname}&nbsp;&nbsp;
                                </Grid>
                                <Grid item>
                                    {row?.user_role == "Admin" &&
                                        <Box className={`${dashboardStyle.adminlabel}`}>
                                            {row?.user_role}
                                        </Box>
                                    }
                                </Grid>

                            </Grid>
                        </Grid>
                    </>
                )
            }
        },
        {
            field: 'email',
            headerName: 'EMAIL',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 300,
            renderCell: (params: any) => {
                let row = params.row
                return (
                    <>{row.email}</>
                )
            }
        },
        {
            field: 'phone_number',
            headerName: 'PHONE NUMBER',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 150,
            renderCell: (params: any) => {
                let row = params.row
                return (
                    <>{row.phone_number}</>
                )
            }
        },
        {
            field: 'status',
            headerName: 'STATUS',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 150,
            renderCell: (params: any) => {
                let row = params.row;
                return (
                    <>
                        {row?.status?.toLowerCase() === "active" ? (
                            <span style={{ color: 'rgba(23, 214, 0, 1)' }}>Active</span>
                        ) : (
                            <span style={{ color: 'red' }}>Inactive</span>
                        )}
                    </>
                );
            }
        },
        {
            field: 'created_date',
            headerName: 'CREATED AT',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 200,
            renderCell: (params: any) => {
                let row = params.row.created_date
                let date = row ? moment(row)?.format("MM/DD/YYYY  hh:mm A") : "";
                return (
                    <>
                        <span>{date}</span>
                    </>
                )
            }
        },
        {
            field: 'last_login',
            headerName: 'LAST LOGIN',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 200,
            renderCell: (params: any) => {
                let row = params.row.last_login
                let date = row ? moment(row)?.format("MM/DD/YYYY  hh:mm A") : "";
                return (
                    <>
                        <span>{date}</span>
                    </>
                )
            }
        },
        {
            field: 'profile_count',
            headerName: '# PROFILES',
            align: 'left',
            headerAlign: 'left',
            // flex: 1,
            width: 100,
            renderCell: (params: any) => {
                let row = params.row
                return (
                    <>{row.profile_count}</>
                )
            }
        },
    ]

    const companyDetailsColumns: any = [
        {
            field: 'company',
            headerName: 'COMPANIES',
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            // width: 360,
            renderCell: (params: any) => {
                let row = params.row

                return (
                    <>{row.company}</>
                )
            }
        },
        {
            field: 'agents',
            headerName: '# AGENTS',
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            // width: 360,
            renderCell: (params: any) => {
                let row = params.row

                return (
                    <>{row.agents}</>
                )
            }
        },
        {
            field: 'activeAgents',
            headerName: '# ACTIVE AGENTS',
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            // width: 360,
            renderCell: (params: any) => {
                let row = params.row

                return (
                    <>{row.activeAgents}</>
                )
            }
        },
        {
            field: 'newProfiles',
            headerName: '# NEW PROFILES',
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            // width: 360,
            renderCell: (params: any) => {
                let row = params.row

                return (
                    <>{row.newProfiles}</>
                )
            }
        }
    ]

    const handleShortcutSelect = (shortcut: any, event: any) => {
        if (shortcut.value && Array.isArray(shortcut.value)) {
            const [start, end] = shortcut.value;
            setDateRange({
                startDate: moment(start).format('YYYY-MM-DD'),
                endDate: moment(end).format('YYYY-MM-DD')
            });
        } else if (typeof shortcut.value === 'function') {
            // Handle dynamic shortcuts (like 'Last week', 'Next week')
            const [start, end] = shortcut.value([new Date()]);
            setDateRange({
                startDate: moment(start).format('YYYY-MM-DD'),
                endDate: moment(end).format('YYYY-MM-DD')
            });
        }
    };

    const handleDateRangeSelect = (value: [Date, Date]) => {
        if (value && value.length === 2) {
            const [start, end] = value;
            setDateRange({
                startDate: moment(start).format('YYYY-MM-DD'),
                endDate: moment(end).format('YYYY-MM-DD')
            });
        }
    };

    const handleCompanyChange = (event: any, newValue: string | null) => {
        setSelectedCompany(newValue);

        setSuperAdminDashboardData((prevData: any) => {
            if (!prevData.originalListOfAgents) {
                return {
                    ...prevData,
                    originalListOfAgents: prevData.list_of_agents,
                    list_of_agents: newValue === "All Companies"
                        ? prevData.list_of_agents
                        : prevData.list_of_agents.filter((agent: any) => agent.company_name === newValue)
                };
            }

            return {
                ...prevData,
                list_of_agents: newValue === "All Companies"
                    ? prevData.originalListOfAgents
                    : prevData.originalListOfAgents.filter((agent: any) => agent.company_name === newValue)
            };
        });
    };

    const getSuperAdminDashboardDetailsFunction = async (startDate: string, endDate: string) => {
        try {
            setFlagLoader(true)
            const response = await getSuperAdminDashboardDetailsAPI(startDate, endDate);
            if (response?.status) {
                if (response?.data) {
                    const mappedData: any = {
                        overall: response?.data?.overall,
                        company_details: response?.data?.company_details,
                        list_of_agents: response?.data?.list_of_agents,
                        originalListOfAgents: response?.data?.list_of_agents
                    };
                    const uniqueCompanies = ["All Companies", ...mappedData?.company_details?.map((item: any) => item?.company)];
                    setCompanyOptions(uniqueCompanies);
                    setSuperAdminDashboardData(mappedData);
                    setFlagLoader(false)
                }
                setFlagLoader(false)
            } else {
                const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
                setFlagLoader(false)
                showSnackbar(errorMessage, 'error');
            }
        } catch (error) {
            console.log(error, "Something went wrong!")
            setFlagLoader(false)
        } finally {
            setFlagLoader(false)
        }
    }

    useEffect(() => {
        getSuperAdminDashboardDetailsFunction(dateRange.startDate, dateRange.endDate);
    }, [dateRange.startDate, dateRange.endDate]);

    function NoRowsOverlay() {
        return (
            <Stack height="100%" alignItems="center" justifyContent="center" color="#0F172B">
                No Data Found
            </Stack>
        );
    }

    const dashboardGridSx = {
        borderRadius: '5px',
        overflow: 'hidden',
        "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#F2F6F9",
            color: '#45556C',
            fontSize: '14px',
            fontWeight: 600,
            textTransform: 'uppercase',
            border: 'none',
            minHeight: "54px !important"
        },
        "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "start !important"
        },
        "& .MuiDataGrid-columnHeader": {
            padding: '0 16px',
            outline: 'none !important',
            justifyContent: 'flex-start',
        },
        "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 600,
            textAlign: 'left',
        },
        "& .MuiDataGrid-main": {
            backgroundColor: "#ffffff",
            borderRadius: "5px 5px 0px 0px",
            borderTop: "1px solid #E2E8F0",
            borderLeft: "1px solid #E2E8F0",
            borderRight: "1px solid #E2E8F0",
            borderBottom: "none",
        },
        "& .MuiDataGrid-row": {
            backgroundColor: "#ffffff",
            borderBottom: '1px solid #E2E8F0 !important',
            '&:hover': {
                backgroundColor: '#f3f4f6 !important',
            },
        },
        "& .MuiDataGrid-cell": {
            borderBottom: 'none',
            padding: '0 16px',
            fontSize: '14px !important',
            outline: 'none !important',
        },
        "& .MuiDataGrid-cell:focus": {
            outline: 'none !important',
        },
        "& .MuiDataGrid-cell:focus-within": {
            outline: 'none !important',
        },
        "& .MuiDataGrid-cell:hover": {
            cursor: "pointer",
        },
        "& .MuiDataGrid-columnSeparator": {
            display: 'none',
        },
        "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            borderLeft: "1px solid #E2E8F0",
            borderRight: "1px solid #E2E8F0",
            borderBottom: "1px solid #E2E8F0",
            backgroundColor: '#F2F6F9',
            minHeight: '52px',
            padding: '0 16px',
            borderRadius: "0px 0px 5px 5px"
        },
        "& .MuiTablePagination-root": {
            color: '#6b7280',
        },
        "& .MuiTablePagination-actions": {
            color: '#6b7280',
        },
        "& .MuiTablePagination-actions .MuiIconButton-root": {
            color: "#6b7280",
        },
        "& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled": {
            color: "#d1d5db",
        },
        "& .MuiTablePagination-displayedRows": {
            color: '#6b7280',
            fontSize: '14px',
        },
        "& .MuiDataGrid-overlay": {
            backgroundColor: "#ffffff",
        },
        "& .MuiDataGrid-columnHeader--moving": {
            backgroundColor: "transparent",
        },
        "& .MuiDataGrid-virtualScrollerContent": {
            marginTop: "18px"
        }
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12} className={dashboardStyle.overallMainItem}>
                    <Grid container padding={"20px"}>
                        <Grid item xs={12} className={dashboardStyle.chipMainItem}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Grid container className={dashboardStyle.chipContainerWrapper}>
                                        <Grid item xs={12}>
                                            <Grid container className={dashboardStyle.chipContainerMain}>
                                                {chipDetails.map((ele) => {
                                                    return (
                                                        <Grid
                                                            key={ele.name}
                                                            item
                                                            xs={3}
                                                            sm={2}
                                                            md={2}
                                                            lg={4}
                                                            xl={4}
                                                            className={`${dashboardStyle.chipCommanStyle} ${ele.flag ? dashboardStyle.chipItemLarge : dashboardStyle.chipItem}`}
                                                        >
                                                            <Grid container sx={{ height: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <Grid item className={dashboardStyle.chipLogoContainer}>
                                                                    {typeof ele.img === 'string'
                                                                        ? <img src={ele.img} alt="" />
                                                                        : <ele.img sx={{ color: '#04385D' }} />
                                                                    }
                                                                </Grid>
                                                                <Grid item className={dashboardStyle.chipContentItem}>
                                                                    <Grid container>
                                                                        <Grid item xs={12} className={dashboardStyle.chipHeadItem}>
                                                                            <Typography component='span'>
                                                                                {ele.name}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={12} className={dashboardStyle.chipSubheadItem}>
                                                                            <Typography component='span'>
                                                                                {ele.number}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={dashboardStyle.companyTableItem}>
                            <Grid container gap={2}>
                                <Grid item xs={12}>
                                    <Grid container sx={{ justifyContent: 'space-between' }}>
                                        <Grid item xs={3}>
                                            <Typography component='span' className={dashboardStyle.cdHeadText}>
                                                Company Details
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8} sx={{ textAlign: 'end' }}>
                                            <Grid container sx={{ gap: '20px', justifyContent: 'end' }}>
                                                <Grid item xs={6.5}>
                                                    <CustomDateRangePicker
                                                        handleDateRangeSelect={handleDateRangeSelect}
                                                        handleShortcutSelect={handleShortcutSelect}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <DataGrid
                                        getRowId={(row) => `${row.company}_${row.company_id || Date.now()}`}
                                        rows={superAdminDashboardData?.company_details || []}
                                        columns={companyDetailsColumns}
                                        components={{
                                            Pagination: CustomPagination,
                                            NoRowsOverlay
                                        }}
                                        autoHeight
                                        hideFooterSelectedRowCount
                                        pageSize={10}
                                        rowsPerPageOptions={[5]}
                                        disableColumnFilter
                                        disableColumnMenu
                                        disableColumnSelector
                                        disableDensitySelector
                                        disableSelectionOnClick
                                        density="compact"
                                        sx={dashboardGridSx}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={dashboardStyle.agentTableItem}>
                            <Grid container gap={2}>
                                <Grid item xs={12}>
                                    <Grid container sx={{ justifyContent: 'space-between', alignItems: "center" }}>
                                        <Grid item xs={5}>
                                            <Typography component='span' className={dashboardStyle.cdHeadText}>
                                                List of Agents
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sx={{ textAlign: 'end' }} className={dashboardStyle.dashboardMonthDropdownItem}>
                                            <FormControl size='medium' fullWidth sx={{ height: '100%' }}>
                                                <Autocomplete
                                                    disableClearable
                                                    fullWidth
                                                    className={dashboardStyle.dashboardMonthDropdown}
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    onChange={handleCompanyChange}
                                                    value={selectedCompany}
                                                    getOptionLabel={(option) => option || ''}
                                                    options={companyOptions || []}
                                                    renderInput={(params) => <TextField {...params} size="small" variant="outlined" placeholder='All Companies' />}
                                                    sx={{
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            border: "1px solid #E2E8F0",
                                                        },
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <DataGrid
                                        getRowId={(userData: any) => (userData.user_id)}
                                        rows={superAdminDashboardData?.list_of_agents || []}
                                        columns={agentListColumns}
                                        components={{
                                            Pagination: CustomPagination,
                                            NoRowsOverlay
                                        }}
                                        autoHeight
                                        hideFooterSelectedRowCount
                                        pageSize={10}
                                        rowsPerPageOptions={[5]}
                                        disableColumnFilter
                                        disableColumnMenu
                                        disableColumnSelector
                                        disableDensitySelector
                                        disableSelectionOnClick
                                        density="compact"
                                        sx={dashboardGridSx}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SuperAdminDashboard